import Colors from "./Colors";

const SIZES = {
  // global sizes
  base: 8,
  font: 14,
  radius_sm: 4,
  radius: 30,
  padding: 20,
  padding2: 12,

  // font sizes
  h9: 9,
  h10: 10,
  h11: 11,
  h12: 12,
  h13: 13,
  h14: 14,
  h15: 15,
  h16: 16,
  h17: 17,
  h18: 18,
  h19: 19,
  h20: 20,
  h21: 21,
  h22: 22,
  h23: 23,
  h24: 24,
  h25: 25,
  h26: 26,
  h27: 27,
  h28: 28,
  h30: 30,
  h32: 32,
};

const STYLES = {
  HorizontalAlign: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  HorizontalLeftAlign: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row",
  },

  spaceBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  borderShadow: {
    boxShadow: "1px 3px 10px 1px #6665",
    backgroundColor: Colors.whiteThemeColor,
  },
  verticalSpaceBetween: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  VerticalAlign: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  VerticalLeftAlign: {
    display: "flex",
    flexDirection: "column",
  },
  MH5: {
    marginLeft: 5,
    marginRight: 5,
  },
  MH10: {
    marginLeft: 10,
    marginRight: 10,
  },
  MH15: {
    marginLeft: 15,
    marginRight: 15,
  },
  MH20: {
    marginLeft: 20,
    marginRight: 20,
  },
  MV5: {
    marginTop: 5,
    marginBottom: 5,
  },
  MV10: {
    marginTop: 10,
    marginBottom: 10,
  },
  MV15: {
    marginTop: 15,
    marginBottom: 15,
  },
  MV20: {
    marginTop: 20,
    marginBottom: 20,
  },
};

const FONTS = {
  // Regular
  Regular10: {
    color: Colors.blackColor,
    fontSize: SIZES.h10,
  },
  Regular12: {
    fontSize: SIZES.h12,
    color: Colors.blackColor,
  },
  Regular13: {
    fontSize: SIZES.h13,
    color: Colors.blackColor,
  },
  Regular14: {
    fontSize: SIZES.h14,
    color: Colors.blackColor,
  },
  Regular15: {
    fontSize: SIZES.h15,
    color: Colors.blackColor,
  },

  Regular16: {
    fontSize: SIZES.h16,
    color: Colors.blackColor,
  },

  Regular19: {
    fontSize: SIZES.h19,
    color: Colors.blackColor,
  },

  Regular24: {
    fontSize: SIZES.h24,
    color: Colors.blackColor,
  },

  // Medium
  Medium11: {
    fontWeight: "500",
    fontSize: SIZES.h11,
    color: Colors.blackColor,
  },
  Medium13: {
    fontWeight: "500",

    fontSize: SIZES.h13,
    color: Colors.blackColor,
  },
  Medium15: {
    fontWeight: "500",

    fontSize: SIZES.h15,
    color: Colors.blackColor,
  },
  Medium17: {
    fontWeight: "500",

    fontSize: SIZES.h17,
    color: Colors.blackColor,
  },
  Medium20: {
    fontWeight: "500",

    fontSize: SIZES.h20,
    color: Colors.blackColor,
  },
  Medium19: {
    fontWeight: "700",

    fontSize: SIZES.h19,
    color: Colors.blackColor,
  },
  Medium24: {
    fontWeight: "700",

    fontSize: SIZES.h24,
    color: Colors.blackColor,
  },
  Medium28: {
    fontWeight: "500",
    fontSize: SIZES.h28,
    color: Colors.blackColor,
  },

  //SemiBold
  SemiBold10: {
    fontWeight: "700",

    fontSize: SIZES.h10,
    color: Colors.blackColor,
  },

  SemiBold12: {
    fontWeight: "700",

    fontSize: SIZES.h12,
    color: Colors.blackColor,
  },
  SemiBold14: {
    fontWeight: "700",

    fontSize: SIZES.h14,
    color: Colors.blackColor,
  },
  SemiBold15: {
    fontWeight: "700",

    fontSize: SIZES.h15,
    color: Colors.blackColor,
  },
  SemiBold28: {
    fontWeight: "700",

    fontSize: SIZES.h28,
    color: Colors.blackColor,
  },
  SemiBold24: {
    fontWeight: "700",

    fontSize: SIZES.h24,
    color: Colors.blackColor,
  },
  SemiBold20: {
    fontWeight: "700",

    fontSize: SIZES.h20,
    color: Colors.blackColor,
  },
  SemiBold18: {
    fontWeight: "700",

    fontSize: SIZES.h18,
    color: Colors.blackColor,
  },
  SemiBold16: {
    fontWeight: "700",

    fontSize: SIZES.h16,
    color: Colors.blackColor,
  },

  //Bold
  Bold10: {
    fontWeight: "bold",
    fontSize: SIZES.h10,
    color: Colors.blackColor,
  },
  Bold12: {
    fontWeight: "bold",
    fontSize: SIZES.h12,
    color: Colors.blackColor,
  },
  Bold13: {
    fontWeight: "bold",
    fontSize: SIZES.h13,
    color: Colors.blackColor,
  },
  Bold14: {
    fontWeight: "bold",
    fontSize: SIZES.h14,
    color: Colors.blackColor,
  },
  Bold15: {
    fontSize: SIZES.h15,
    fontWeight: "bold",
    color: Colors.blackColor,
  },
  Bold16: {
    fontWeight: "bold",
    fontSize: SIZES.h16,
    color: Colors.blackColor,
  },
  Bold18: {
    fontWeight: "bold",
    fontSize: SIZES.h18,
    color: Colors.blackColor,
  },
  Bold20: {
    fontWeight: "bold",
    fontSize: SIZES.h20,
    color: Colors.blackColor,
  },

  // light
  light15: {
    fontFamily: "Gilroy-Light",
    color: Colors.blackColor,
    fontSize: SIZES.h15,
  },
  light14: {
    fontFamily: "Gilroy-Light",
    color: Colors.blackColor,
    fontSize: SIZES.h14,
  },
  light10: {
    fontFamily: "Gilroy-Light",
    color: Colors.blackColor,
    fontSize: SIZES.h10,
  },
  light9: {
    fontFamily: "Gilroy-Light",
    color: Colors.blackColor,
    fontSize: SIZES.h9,
  },
};
export { SIZES, FONTS, STYLES };
